import o from "./highrise286.mjs";
/* empty css             */
/* empty css             */
import t from "./highrise181.mjs";
const f = /* @__PURE__ */ t(o, [["__scopeId", "data-v-45f1ba6e"]]);
export {
  f as default
};
